/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Mock_Rate_LabelInputs */

const en_st_mock_rate_label = /** @type {(inputs: St_Mock_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass rate`)
};

const id_st_mock_rate_label = /** @type {(inputs: St_Mock_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat lulus`)
};

/**
* | output |
* | --- |
* | "Pass rate" |
*
* @param {St_Mock_Rate_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_mock_rate_label = /** @type {((inputs?: St_Mock_Rate_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Mock_Rate_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_mock_rate_label(inputs)
	return en_st_mock_rate_label(inputs)
});